export const sources = {
	funda: {
		src: "/logos/funda_ico.svg",
		alt: "Funda",
	},
	epOnline: {
		src: "/logos/rijksoverheid_ico.svg",
		alt: "EP-Online",
	},
	wozWaardeLoket: {
		src: "/logos/woz_ico.svg",
		alt: "WOZ-waardeloket",
	},
	kadaster: {
		src: "/logos/kadaster_ico.svg",
		alt: "Kadaster",
	},
};

export interface DataSource {
	value: any;
	source: keyof typeof sources;
	transformer?: (value: any) => any;
	onApply?: (value: any) => void;
	tooltip?: string;
}
